export const AVAILABLE_CUSTOM_ROLE_PERMISSIONS = [
  'conversation_manage',
  'conversation_assign_manual',
  'conversation_transfer_assigned',
  'conversation_transfer_all',
  'voice_call_transfer',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
  'contact_manage',
  'report_manage',
  'knowledge_base_manage',
  'ticket_manage',
  'company_manage',
  'crm_manage',
  'calendar_manage',
  'campaign_manage',
  'lumerai_manage',
  'workflow_manage',
  'account_manage',
  'agent_manage',
  'team_manage',
  'inbox_manage',
  'label_manage',
  'custom_attribute_manage',
  'automation_manage',
  'macro_manage',
  'canned_response_manage',
  'integration_manage',
  'audit_log_manage',
  'custom_role_manage',
  'sla_manage',
  'security_manage',
  'location_manage',
  'staff_sticker_manage',
  'sms_manage',
  'alert_manage',
  'billing_manage',
  'lumera_app_billing_view',
  'api_manage',
  'webhook_manage',
  'custom_tool_manage',
  'white_label_manage',
];

export const ROLES = ['agent', 'administrator'];

export const CONVERSATION_PERMISSIONS = [
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
];

export const MANAGE_ALL_CONVERSATION_PERMISSIONS = 'conversation_manage';

export const CONVERSATION_UNASSIGNED_PERMISSIONS =
  'conversation_unassigned_manage';

export const CONVERSATION_PARTICIPATING_PERMISSIONS =
  'conversation_participating_manage';

export const CONVERSATION_TRANSFER_PERMISSIONS = [
  'conversation_transfer_assigned',
  'conversation_transfer_all',
];

export const CONTACT_PERMISSIONS = 'contact_manage';

export const REPORTS_PERMISSIONS = 'report_manage';

export const ASSIGNEE_TYPE_TAB_PERMISSIONS = {
  me: {
    count: 'mineCount',
    permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
  },
  assigned_to_others: {
    count: 'assignedToOthersCount',
    permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
  },
  unassigned: {
    count: 'unAssignedCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_UNASSIGNED_PERMISSIONS,
    ],
  },
  bot: {
    count: 'botCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_UNASSIGNED_PERMISSIONS,
    ],
  },
  events: {
    count: 'eventsCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_UNASSIGNED_PERMISSIONS,
    ],
  },
  campaigns: {
    count: 'campaignsCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_UNASSIGNED_PERMISSIONS,
    ],
  },
  all: {
    count: 'allCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_PARTICIPATING_PERMISSIONS,
    ],
  },
};
